import React ,{useEffect} from 'react';
import AOS from 'aos';
import SignupForm from '../Components/Pages/SignUp/SignupForm';
import Header from '../Components/Shared/Header/Header';
import Footer from '../Components/Shared/Footer/Footer';
function Signup(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled" />
        <SignupForm />
        <Footer />
        </>
    )
};
export default Signup ;